<template>
  <div class="tank-info">
    <div v-if="level != null" :style="{ color: fontColor }">
      {{level}}m
    </div>
    <div v-else>
      - m
    </div>
    <div v-if="tonn != null">
      {{tonn}}t
    </div>
    <div v-else>
      - t
    </div>
  </div>
</template>

<script>

export default {
  props: {
    level: { type: String },
    tonn: { type: String },
    fontColor: { type: String },
  }
}
</script>

<style lang="scss">
.tank-info {
  padding: 5px;
}
</style>